import { render, staticRenderFns } from "./PurchaseSteps.vue?vue&type=template&id=5d07a9a6&scoped=true&"
import script from "./PurchaseSteps.vue?vue&type=script&lang=js&"
export * from "./PurchaseSteps.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSteps.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PurchaseSteps.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PurchaseSteps.vue?vue&type=style&index=2&id=5d07a9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07a9a6",
  null
  
)

export default component.exports